import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    GET_BORROW_REQUEST,
    GET_SENT_BORROW_REQUEST,
    REGISTER_BORROW_REQUEST_APPROVAL_BY_BORROWER,
    REGISTER_BORROW_REQUEST_APPROVAL_BY_OWNER, SEND_APPROVAL_OTP,
} from "./Cartable.type";
import CartableService from "../services/Cartable.service";
import {BorrowRequestApprovalByOwner} from "../models";

export const getReceivedBorrowRequest = createAsyncThunk(
    GET_BORROW_REQUEST,
    async (model:any) =>{
        const response = await CartableService.getReceivedBorrowRequest(model);
        return response.data;
    }
)
export const getSentBorrowRequest = createAsyncThunk(
    GET_SENT_BORROW_REQUEST,
    async () =>{
        const response = await CartableService.getSentBorrowRequest();
        return response.data;
    }
)
export const registerBorrowRequestApprovalByOwner = createAsyncThunk(
    REGISTER_BORROW_REQUEST_APPROVAL_BY_OWNER,
    async (model:BorrowRequestApprovalByOwner) =>{
        const response = await CartableService.registerBorrowRequestApprovalByOwner(model);
        return response.data;
    }
)
export const registerBorrowRequestApprovalByBorrower = createAsyncThunk(
    REGISTER_BORROW_REQUEST_APPROVAL_BY_BORROWER,
    async (model:BorrowRequestApprovalByOwner) =>{
        const response = await CartableService.registerBorrowRequestApprovalByBorrower(model);
        return response.data;
    }
)
export const sendApprovalOTP = createAsyncThunk(
    SEND_APPROVAL_OTP,
    async () =>{
        const response = await CartableService.sendApprovalOTP();
        return response.data;
    }
)
